/**
 * MUI theme factory for dink-product-admin. White-label-friendly — palette
 * tokens are the extension point if per-tenant branding is ever introduced.
 */
import { createTheme, type Theme } from '@mui/material/styles';

export function createAppTheme(): Theme {
  return createTheme({
    palette: {
      mode: 'light',
      // #0f766e (not the lighter #0d9488): the lighter shade measures only a
      // 3.52:1 contrast ratio against both `background.default` (#f7f8fa,
      // used as outlined-button text-on-background and as the Avatar's
      // contrastText-on-primary background) — a WCAG AA `color-contrast`
      // violation caught by DNKPDM-0005's axe scan (tests 6/7). This shade
      // clears 4.5:1 in both directions (~5.15:1 against #f7f8fa, ~5.48:1
      // against white) with margin.
      primary: { main: '#0f766e' },
      secondary: { main: '#4f46e5' },
      success: { main: '#15803d' },
      warning: { main: '#b45309' },
      error: { main: '#b91c1c' },
      info: { main: '#0369a1' },
      background: { default: '#f7f8fa', paper: '#ffffff' },
    },
    typography: {
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
      ].join(','),
      h1: { fontSize: '1.75rem', fontWeight: 600 },
      h2: { fontSize: '1.25rem', fontWeight: 600 },
      h3: { fontSize: '1.05rem', fontWeight: 600 },
    },
    shape: { borderRadius: 8 },
    components: {
      MuiButton: {
        styleOverrides: {
          root: { textTransform: 'none', fontWeight: 500 },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: { fontWeight: 500 },
        },
      },
    },
  });
}
